import { Component, Inject, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonDataModel } from '../common-data-model';

@Component({
  selector: 'app-cushioning-details-form',
  templateUrl: './cushioning-details-form.component.html',
  styleUrls: ['./cushioning-details-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CushioningDetailsFormComponent implements OnInit {
  commonDataModel = new CommonDataModel();
  facesDetails = this.commonDataModel.facesModel;
  isFormLoading = false;
  cushioningDetails: any;
  packagingName: any;
  isDisabledForm = false;
  isCustomCushioning = false;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CushioningDetailsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.cushioningDetails = data.cushioningDetails;
      this.packagingName = data.packagingName;
      this.isDisabledForm = data.isDisabledForm;
      this.getfaceDetails();
  }

  ngOnInit() {
  }

  getfaceDetails() {
    this.facesDetails.end1 = this.cushioningDetails[0];
    this.facesDetails.end2 = this.cushioningDetails[1];
    this.facesDetails.side1 = this.cushioningDetails[2];
    this.facesDetails.side2 = this.cushioningDetails[3];
    this.facesDetails.top = this.cushioningDetails[4];
    this.facesDetails.bottom = this.cushioningDetails[5];
  }

  onSaveCushioningDetails() {
    this.onClose(false);
  }

  onFaceCheckBoxChange(event: any, faceId: number) {
    // if (!event.checked) {
    //   this.updateDimentions(faceId);
    // }
  }

  updateDimentions(faceId: number) {
    switch (faceId) {
      case 1: {
          this.facesDetails.end1.length = 0;
          this.facesDetails.end1.width = 0;
          this.facesDetails.end1.quantity = 0;
          break;
      }
      case 2: {
          this.facesDetails.end2.length = 0;
          this.facesDetails.end2.width = 0;
          this.facesDetails.end2.quantity = 0;
          break;
      }
      case 3: {
          this.facesDetails.side1.length = 0;
          this.facesDetails.side1.width = 0;
          this.facesDetails.side1.quantity = 0;
          break;
      }
      case 4: {
          this.facesDetails.side2.length = 0;
          this.facesDetails.side2.width = 0;
          this.facesDetails.side2.quantity = 0;
          break;
      }
      case 5: {
          this.facesDetails.top.length = 0;
          this.facesDetails.top.width = 0;
          this.facesDetails.top.quantity = 0;
          break;
      }
      case 6: {
        this.facesDetails.bottom.length = 0;
        this.facesDetails.bottom.width = 0;
        this.facesDetails.bottom.quantity = 0;
        break;
      }
    }

  }

  onClose(isClosed: boolean): void {
    this.dialogRef.close({ isClosed, data: this.cushioningDetails, isCustomCushioning: this.isCustomCushioning });
  }

  onChange(event: any){
    this.isCustomCushioning = true;
  }
}
